import { Epic, ofType } from 'redux-observable';
import { from, timer } from 'rxjs';
import { exhaustMap, map, switchMap, takeUntil } from 'rxjs/operators';

import { get } from '../api';

import { POLL_RELEASE_START, POLL_RELEASE_STOP } from './actions';

export const pollRelease: Epic = (action$, state$: any) => action$.pipe(
  ofType(POLL_RELEASE_START),
  switchMap(() =>
    timer(7000, 7000).pipe(
      takeUntil(action$.pipe(
        ofType(POLL_RELEASE_STOP),
      )),
      exhaustMap(() =>
        from(state$.value.projectGroups.pollRelease).pipe(
          exhaustMap(({ projectGroupId, releaseId }) =>
            from(get(`/api/project_group/${projectGroupId}/release/${releaseId}`, false)).pipe(
              map(response => ({ type: 'FETCH_PROJECT_GROUP_RELEASE_FULFILLED', payload: response }))
            )
          )
        ),
      ),
    ),
  ),
);

export default pollRelease;
